/* @ts-nocheck */
/* eslint-disable */
(function ($) {
  var DEFAULT_AUTOPLAY_SPEED_MS = 5000;
  var FADE_SPEED_MS = 600;

  function initLookSlideshows(container) {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var $scope = container ? $(container) : $(document);

    $scope.find('.c21-look-slideshow').each(function () {
      var $slideshow = $(this);

      if ($slideshow.hasClass('slick-initialized')) return;

      $slideshow.slick({
        infinite: true,
        autoplay: !prefersReducedMotion,
        autoplaySpeed: DEFAULT_AUTOPLAY_SPEED_MS,
        pauseOnHover: true,
        pauseOnFocus: true,
        arrows: false,
        dots: false,
        fade: true,
        speed: FADE_SPEED_MS,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        // fade mode's opacity-based transition doesn't match Slick's
        // slide-position touch-drag handling, which can flash a blank
        // frame mid-swipe. This slideshow is autoplay-only by design
        // (no arrows/dots), so manual dragging was never a feature —
        // disabling it removes the glitch outright.
        swipe: false,
        draggable: false
      });

      // Slick's own pauseOnFocus only reacts to focus landing inside its
      // track. The only real Tab stop here is the wrapping <a> (the look's
      // collection link), which is a parent of the slideshow, not a
      // descendant — so Slick never sees that focus event and keyboard
      // users could never pause autoplay. Handle it directly on the link.
      var $wrapLink = $slideshow.closest('a');
      if ($wrapLink.length && !prefersReducedMotion) {
        $wrapLink.on('focusin.c21LookSlideshow', function () {
          $slideshow.slick('slickPause');
        });
        $wrapLink.on('focusout.c21LookSlideshow', function () {
          $slideshow.slick('slickPlay');
        });
      }
    });
  }

  $(function () {
    initLookSlideshows();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initLookSlideshows(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var $scope = $(e.target);
    $scope.find('.c21-look-slideshow').closest('a').off('.c21LookSlideshow');
    $scope.find('.c21-look-slideshow.slick-initialized').slick('unslick');
  });
})(jQuery);
